import React from 'react';

export default function ProfileTabs({ tabs, activeTab, onTabChange }) {
  return (
    <div className="profile-tabs mb-3">
      {tabs.map((t) => (
        <button
          key={t.id}
          className={`profile-tab${activeTab === t.id ? ' active' : ''}`}
          onClick={() => onTabChange(t.id)}
          type="button"
        >
          {t.label}
          {typeof t.count === 'number' && t.count > 0 && (
            <span className="tab-count">{t.count}</span>
          )}
          {t.dot === 'green' && <span className="tab-dot green" />}
          {t.dot === 'amber' && <span className="tab-dot amber" />}
        </button>
      ))}
    </div>
  );
}
